'use client';

import { useStripeContext } from '@/context/StripeContextProvider';
import { Wrapper } from 'web-checkout-package';
import { initPixel } from "@/utils/pixel";
import { useEffect } from 'react';

export const PaymentPage = ({ paymentData, paymentVariation }) => {
	const { userEmail } = useStripeContext();

	useEffect(() => {
		if (paymentData) {
			initPixel()
				.then(ReactPixel => {
					ReactPixel.default.trackCustom("stripe_payment_page_viewed");
				})
		}
	}, [paymentData]);

	if (!paymentData) {
		return null;
	}

	return (
		<div className="h-dvh overflow-y-auto overflow-x-hidden">
			<Wrapper
				variant={paymentVariation}
				userEmail={userEmail || ""}
				elements={paymentData.elements}
				express={paymentData.express}
				pricesData={paymentData.prices}
				customer={paymentData.customer}
			/>
		</div>
	);
};
